export const CHARGE_TYPE_MAPPING = {
  no_charge: 'no_charge',
  pay_per_use: 'pay_per_use',
  landlord: 'landlord',
  tenant: 'tenant',
};
